import { render } from "./TheTitle.vue?vue&type=template&id=a148d54e&scoped=true"
import script from "./TheTitle.vue?vue&type=script&lang=js"
export * from "./TheTitle.vue?vue&type=script&lang=js"

import "./TheTitle.vue?vue&type=style&index=0&id=a148d54e&lang=scss&scoped=true"

import exportComponent from "C:\\password-generator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a148d54e"]])

export default __exports__